export default __webpack_public_path__ + "static/og-fallback-4e7002420aa504d00b389cf130c1b6a0.png";